module.exports = __webpack_public_path__ + "img/diagnose_2mal7.00f43617.png";